/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonRelayerSummaryInfo } from './BabylonRelayerSummaryInfo';

export type BabylonRelayerInfo = {
    RLYR: BabylonRelayerSummaryInfo;
    STAT: BabylonRelayerInfo.STAT;
    TCHCNT: string;
    OPCHCNT: string;
    RCVTRXCNT: string;
    SNDTRXCNT: string;
    TTRXCNT: string;
    AG: string;
    UT: number;
};

export namespace BabylonRelayerInfo {

    export enum STAT {
        OPENED = 'OPENED',
        CLOSED = 'CLOSED',
    }


}

